import { jsonRequest, uploadFileRequest } from '../helpers/apiRequest'

import { baseUrl } from '../helpers/baseUrl'
import moment from 'moment'
import { getUrlWithQueryString } from '../helpers/util'

function transferToAccount(
  senderAccountId,
  sendingAmount,
  receiverAccountId,
  receivingAmount,
  futureDate,
  exchangeType,
  amountCurrency,
  specialRateRequest,
  description,
  userComment
) {
  let params = {
    senderAccountId: senderAccountId,
    senderAmount: sendingAmount,
    receiverAccountId: receiverAccountId,
    receiverAmount: receivingAmount,
    futureDate: futureDate
      ? moment(futureDate, 'DD/MM/YYYY')
          .startOf('days')
          .unix()
      : undefined,
    isFuture: !!futureDate,
    exchangeType: exchangeType,
    amountCurrency: amountCurrency,
    userComment: userComment,
    description: description,
    specialRateRequest: !!specialRateRequest
  }
  return jsonRequest(
    `${baseUrl}/transfer/v2/between-own-accounts`,
    true,
    params,
    'POST'
  )
}

function saveTransferToAccount(id, descr, additional) {
  let params = {
    paymentsId: id,
    description: descr,
    additional: additional
  }
  return jsonRequest(
    `${baseUrl}/transfer/v2/between-own-accounts/temporary-storage`,
    true,
    params,
    'PUT',
    {
      badRequest: false
    }
  )
}

function transferToSomeone(params) {
  return jsonRequest(`${baseUrl}/transfer/v2/to-someone`, true, params, 'POST')
}

function confirmTransferToSomeone(params) {
  return jsonRequest(
    `${baseUrl}/transfer/v2/to-someone/confirm`,
    true,
    params,
    'PUT',
    { badRequest: false }
  )
}

function saveTransferToSomeone(params) {
  return jsonRequest(
    `${baseUrl}/transfer/v2/to-someone/temporary-storage`,
    true,
    params,
    'PUT',
    { badRequest: false }
  )
}

function transferToBudgetByMySelf(
  senderAccountId,
  amount,
  treasuryCode,
  description,
  futureDate
) {
  let params = {
    senderAccountId: senderAccountId,
    amount: amount,
    treasuryCode: treasuryCode,
    description: description,
    futureDate: futureDate
      ? moment(futureDate, 'DD/MM/YYYY')
          .startOf('days')
          .unix()
      : undefined,
    isFuture: !!futureDate
  }
  return jsonRequest(
    `${baseUrl}/transfer/v2/in-budget/self`,
    true,
    params,
    'POST'
  )
}

function transferToBudgetByOther(
  senderAccountId,
  amount,
  treasuryCode,
  description,
  futureDate,
  taxPayerName,
  taxPayerCode
) {
  let params = {
    senderAccountId: senderAccountId,
    amount: amount,
    treasuryCode: treasuryCode,
    description: description,
    taxPayerName: taxPayerName,
    taxPayerCode: taxPayerCode,
    futureDate: futureDate
      ? moment(futureDate, 'DD/MM/YYYY')
          .startOf('days')
          .unix()
      : undefined,
    isFuture: !!futureDate
  }
  return jsonRequest(
    `${baseUrl}/transfer/v2/in-budget/other`,
    true,
    params,
    'POST'
  )
}

function resendSms(paymentId) {
  return jsonRequest(
    `${baseUrl}/transfer/v2/two-factor/send-code`,
    true,
    paymentId,
    'POST'
  )
}
function requestBillingOtpCode(paymentId) {
  return jsonRequest(
    `${baseUrl}/billing/v1/validation/send-code`,
    true,
    paymentId,
    'POST'
  )
}

function confirmTransferToBudget(
  id,
  additional,
  description,
  twoFactorCode,
  countryCode,
  validationId
) {
  let params = {
    paymentsId: id,
    twoFactorCode: twoFactorCode,
    SenderDocumentIssuerCountryCode: countryCode ? countryCode : '',
    description: description ? description : '',
    additional: additional ? additional : '',
    validationId: validationId
  }
  return jsonRequest(
    `${baseUrl}/transfer/v2/in-budget/Confirm`,
    true,
    params,
    'PUT'
  )
}

function saveTransferToBudget(id, descr, additional) {
  let params = {
    paymentsId: id,
    description: descr,
    additional: additional
  }
  return jsonRequest(
    `${baseUrl}/transfer/v2/in-budget/temporary-storage`,
    true,
    params,
    'PUT',
    { badRequest: false }
  )
}

function confirmTransferToAccount(id, descr, smsCode) {
  let params = {
    paymentsId: id,
    description: descr,
    TwoFactorCode: smsCode
  }
  return jsonRequest(
    `${baseUrl}/transfer/v2/between-own-accounts/confirm`,
    true,
    params,
    'PUT'
  )
}
function authorizeTransfer(id, validationId, smsCode = '') {
  let params = {
    paymentId: id,
    twoFactorCode: smsCode,
    validationId: validationId
  }
  return jsonRequest(
    `${baseUrl}/currenttask/v1/corporate/authorize`,
    true,
    params,
    'PUT'
  )
}

function fetchBankInfo(iban) {
  return jsonRequest(
    `${baseUrl}/transfer/v2/ToSomeone/BankInfo?iban=${iban}`,
    true,
    null,
    'GET'
  )
}

function fetchExchangeDailyLimit() {
  return jsonRequest(`${baseUrl}/transfer/v2/between-own-accounts/limit`, true)
}

function fetchCountries(query, lang) {
  const qr =
    lang !== 'ka' ? query.toUpperCase(lang) : query[0] + query.substr(1)
  return jsonRequest(
    `${baseUrl}/transfer/v3/to-someone/countries?name=${qr}`,
    true
  )
}

function fetchForeignBanks(query) {
  return jsonRequest(
    `${baseUrl}/transfer/v3/to-someone/foreign-banks?name=${query}`,
    true
  )
}

function uploadInvoice(file) {
  return uploadFileRequest(`${baseUrl}/storage/v1/files`, true, file)
}

function confirmCorporateTransfer(params) {
  let query = Object.keys(params)
    .filter(key => params.hasOwnProperty(key) && params[key])
    .map(key => `${key}=${params[key]}`)
    .join('&')
  return jsonRequest(`${baseUrl}/transfer/v2/corporate/confirm?${query}`, true)
}

function fetchAllowedLimit(params) {
  let query = Object.keys(params)
    .filter(key => params.hasOwnProperty(key) && params[key])
    .map(key => `${key}=${params[key]}`)
    .join('&')
  return jsonRequest(
    `${baseUrl}/transfer/v1/between-own-accounts/limit?${query}`,
    true
  )
}

function fetchAllowedRangesAndLimits(params) {
  let query = Object.keys(params)
    .filter(key => params.hasOwnProperty(key) && params[key])
    .map(key => `${key}=${params[key]}`)
    .join('&')
  return jsonRequest(
    `${baseUrl}/transfer/v2/between-own-accounts/user-limit?${query}`,
    true
  )
}

function createGroupPayment(params) {
  let url = getUrlWithQueryString(
    `${baseUrl}/transfer/v2/group-payments`,
    params
  )
  return jsonRequest(url, true, undefined, 'POST')
}

function createP2pPayment(params) {
  return jsonRequest(`${baseUrl}/transfer/v2/p2p`, true, params, 'POST')
}

function createP2pPaymentByPan(params) {
  return jsonRequest(`${baseUrl}/transfer/v2/p2p/by-pan`, true, params, 'POST')
}

function confirmP2pPayment(params) {
  return jsonRequest(`${baseUrl}/transfer/v2/p2p/confirm`, true, params, 'POST')
}

function confirmP2pPaymentByPan(params) {
  return jsonRequest(
    `${baseUrl}/transfer/v2/p2p/by-pan/confirm`,
    true,
    params,
    'POST'
  )
}

export function createToSomeoneByPersonalInfo(params) {
  return jsonRequest(
    `${baseUrl}/transfer/v2/to-someone-by-client-info`,
    true,
    params,
    'POST'
  )
}
export function checkToSomeoneByPersonalInfo(params) {
  let query = Object.keys(params)
    .filter(key => params.hasOwnProperty(key) && params[key])
    .map(key => `${key}=${params[key]}`)
    .join('&')
  return jsonRequest(
    `${baseUrl}/transfer/v2/to-someone-by-client-info?${query}`,
    true,
    undefined,
    'GET'
  )
}

export function confirmToSomeoneByPersonalInfo(params) {
  return jsonRequest(
    `${baseUrl}/transfer/v2/to-someone-by-client-info/confirm`,
    true,
    params,
    'PUT'
  )
}

// Request Money
function transferToSomeoneRequestedMoney(params) {
  return jsonRequest(
    `${baseUrl}/transfer/v2/request-money/pending-confirmation/create`,
    true,
    params,
    'POST'
  )
}
function confirmTransferToSomeoneRequestedMoney(params = {}) {
  const payload = { ...params, PaymentId: params.PaymentsId }

  if (payload.PaymentsId) {
    delete payload.PaymentsId
  }

  return jsonRequest(
    `${baseUrl}/transfer/v2/request-money/pending-confirmation/confirm`,
    true,
    payload,
    'PUT',
    { badRequest: false }
  )
}

function cancelTransferToAccount(id, reason = '') {
  const paymentsId = `paymentsId=${encodeURIComponent(id)}`
  const reasonForCancel = reason ? `&reasonForCancel=${reason}` : ''
  return jsonRequest(
    `${baseUrl}/transfer/v2/between-own-accounts/cancel?${paymentsId}${reasonForCancel}`,
    true,
    undefined,
    'DELETE',
    { internalServerError: false, badRequest: false }
  )
}

export function fetchSwiftTariffTypes() {
  return jsonRequest(
    `${baseUrl}/transfer/v2/to-someone/swift-tariff-types`,
    true
  )
}
export function fetchSwiftSenderAddress() {
  return jsonRequest(`${baseUrl}/transfer/v3/to-someone/user-address`, true)
}

export default {
  confirmP2pPaymentByPan,
  createP2pPaymentByPan,
  fetchAllowedRangesAndLimits,
  fetchAllowedLimit,
  confirmCorporateTransfer,
  transferToAccount,
  confirmTransferToAccount,
  fetchBankInfo,
  transferToBudgetByMySelf,
  transferToBudgetByOther,
  confirmTransferToBudgetByOther: confirmTransferToBudget,
  confirmTransferToBudgetByMySelf: confirmTransferToBudget,
  uploadInvoice,
  fetchCountries,
  fetchForeignBanks,
  resendSms,
  transferToSomeone,
  confirmTransferToSomeone,
  fetchExchangeDailyLimit,
  saveTransferToAccount,
  saveTransferToBudget,
  saveTransferToSomeone,
  createGroupPayment,
  createP2pPayment,
  confirmP2pPayment,
  authorizeTransfer,
  requestBillingOtpCode,
  transferToSomeoneRequestedMoney,
  confirmTransferToSomeoneRequestedMoney,
  cancelTransferToAccount
}
